<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="decoupagesRepasSvc"></yo-generic-datagrid-pn>
